import aud4 from "@/test_data/demo_data/demo_data_aud4";
import aud5 from "@/test_data/demo_data/demo_data_aud5";
import aud3 from "@/test_data/demo_data/demo_data_aud3";
import aud6 from "@/test_data/demo_data/demo_data_aud6";
import ff_demo from "@/test_data/demo_data/fastfood_demo";
import calgary_demo from "@/test_data/demo_data/multi_market_demo";
import pharma_hcp from "@/test_data/demo_data/pharma_hcp_demo";
import pharma_dtc from "@/test_data/demo_data/pharma_dtc_demo";
// import pharma_dtc from "@/test_data/demo_data/pharma_dtc_demo";
import aud8 from "@/test_data/demo_data/demo_data_aud8";
import aud9 from "@/test_data/demo_data/demo_data_aud9";
import aud10 from "@/test_data/demo_data/demo_data_aud10";
import aud11 from "@/test_data/demo_data/demo_data_aud11";
import aud12 from "@/test_data/demo_data/demo_data_aud12";
import aud13 from "@/test_data/demo_data/demo_data_aud13";
import aud14 from "@/test_data/demo_data/demo_data_aud14";
import aud15 from "@/test_data/demo_data/demo_data_aud15";
import aud16 from "@/test_data/demo_data/demo_data_aud16";

const demo_data = Object.assign({},{"3": aud3},{"4": aud4},{"5": aud5},{"6": aud6},{"7": ff_demo},{"8": calgary_demo},{"9": pharma_hcp},{"10": pharma_dtc},
    {"11": aud8}, {"12": aud9}, {"13": aud10}, {"14": aud12}, {"15": aud11}, {"16": aud13}, {"17": aud14}, {"18": aud15} , {"19": aud16}
);

export default demo_data